import { Injectable } from '@angular/core';

@Injectable()
export class RcrExchangeNavigationServiceService {
  private _canNavigate: boolean;

  get canNavigate() {
    return this._canNavigate;
  }

  set canNavigate(canNavigate: boolean) {
    this._canNavigate = canNavigate;
  }
}
